import formatAmount from '@modules/calculator/utils/formatAmount';
import { getFundingProgress } from './getFundingProgress';
export const mapMyInvestmentsToColumns = (investments, t) => investments.map((investment) => ({
    id: investment.id,
    loanPurpose: investment.loanPurpose,
    loanAmount: formatAmount(+investment.loanAmount),
    loanPeriod: `${investment.loanPeriod} ${t('financing.investing_page_table.months')}`,
    roi: `${investment.roi}%`,
    fundingProgress: getFundingProgress(investment),
    investmentStatus: investment.investmentStatus,
}));
